import { render, staticRenderFns } from "./smshuawei.vue?vue&type=template&id=70cb2fdc"
import script from "./smshuawei.vue?vue&type=script&lang=js"
export * from "./smshuawei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports